// AuthContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import posthog from 'posthog-js'; // Import PostHog

axios.defaults.withCredentials = true;
const AuthContext = createContext(null);
const TOKEN_KEY = 'hv_jwt';

export const AuthProvider = ({ children }) => {
  /*
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem('user');
    return storedUser ? JSON.parse(storedUser) : null;
  });
  /*  state keeps BOTH the auth.userinfo and the raw token  */
  const [auth, setAuth] = useState(() => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) return { user: null, token: null };
    try {
      return { token, user: jwtDecode(token) };
    } catch {                   // bad / expired token
      localStorage.removeItem(TOKEN_KEY);
      return { user: null, token: null };
    }
  }); //*/
/*
  useEffect(() => {
    
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
    } else {
      localStorage.removeItem('user');
      setUser({ role: 'guest' });
    }
     // Configure Axios interceptor when auth.userstate changes
    const interceptor = axios.interceptors.request.use(
      (config) => {
        if (user) {
          config.headers.Authorization = `Bearer ${user.token}`;
          config.headers.Email = user.email;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    return () => {
      // Remove the interceptor when the component unmounts or auth.userchanges
      axios.interceptors.request.eject(interceptor);
    };

  }, [user]);

  /* attach Authorization automatically */
  useEffect(() => {
    const id = axios.interceptors.request.use(cfg => {
      if (auth.token) cfg.headers.Authorization = `Bearer ${auth.token}`;
      return cfg;
    });
    return () => axios.interceptors.request.eject(id);
   }, [auth.user]);
//end new */

  const updateProfile = async (values) => {
    if (! auth.user|| ! auth.user.id) {
      console.error('No auth.userid available for update'+ JSON.stringify(values));
  //    alert('You must be logged in to update your profile.');
      return;
    }

    try {
      const updates = { ...values };
      const response = await axios.post('/api/users/update', {
        id:  auth.user.id,
        updates
      });

      setAuth({ ...auth, user: { ...auth.user, ...updates } });
      
    } catch (error) {
      console.error('Failed to update profile:', error);
      alert('Update failed: ' + error.message);
    }
  };


  const isAdmin = auth.user&&  auth.user.role === 'admin';
  const isCandidate = auth.user&&  auth.user.role === 'candidate';
  const isClient = auth.user&&  auth.user.role === 'client';


  const login = async (email, password) => {
    try {
      const response = await axios.post('/api/login', { email, password });
      if (response.data && response.data.user) {
        setAuth({ user: response.data.user, token: response.data.token });
        
      posthog.identify(
        response.data.user.id,  
        {
          email: response.data.user.email,
          name: response.data.user.name,
          role: response.data.user.role,
        }
      );
      return response.data.user;
        
      } else {
        throw new Error('User data is incomplete.');
      }
    } catch (error) {
      console.error('Login failed:', error.response?.data?.message || error.message);
      throw error;
    }
  };

  const oauthLogin = () => {
    // Redirect to backend to start Google login (browser redirect, not XHR)
    window.location.href = '/api/auth/google';
  };
/*  
  const oauthLogin = async (idToken, accessToken) => {
    try {     
      //const response = await axios.post('/api/oauth-login', { token: idToken, accessToken });
      window.location.href = '/api/auth/google';
      if (response.data && response.data.user) {
        setUser(response.data.user);
        localStorage.setItem('user', JSON.stringify(response.data.user)); // Store the user
        return response.data.user;
      } else {
        throw new Error('OAuth login failed');
      }
    } catch (error) {
      console.error('OAuth login failed:', error.response?.data?.message || error.message);
      throw error;
    }
  };
  */
  const signup = async (values) => {
    try {
      const response = await axios.post('/api/signup', values);
      setAuth({ user: response.data.user, token: response.data.token });
      posthog.identify(
        response.data.user.id,  
        {
          email: response.data.user.email,
          name: response.data.user.name,
          role: response.data.user.role,
        }
      );      
      return response.data.user;
    } catch (error) {
      console.error('Signup failed:', error.response?.data?.message || error.message);
      throw new Error(error.response?.data?.message || 'Signup failed');
    }
  };
/*
  const logout = async () => {
    try {
      await axios.get('/api/auth/logout');
      setUser(null);
      setUser({ role: 'guest' });
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };
  /*  helper for the callback page */
  const logout = async () => {
        await axios.post('/api/logout').catch(() => {});   // ignore if 401
        localStorage.removeItem(TOKEN_KEY);
        setAuth({ user: null, token: null });
      };
    
      /* helper the callback page will call */
      const acceptToken = (token) => {
        if (typeof token !== 'string' || !token.includes('.')) return;
        posthog.reset();
        localStorage.setItem(TOKEN_KEY, token);
        setAuth({ token, user: jwtDecode(token) });
      
        /* ✅  tell the extension */
        if (window.chrome?.runtime?.id) {
          //window.chrome.runtime.sendMessage({ hvAction: 'hvSetToken', token });
          window.postMessage(
            { hvForwardToken: true, token },          // payload
            '*'                                       // same‑origin
          );
        }
      };//*/


  return (
    <AuthContext.Provider value={{ user: auth.user, acceptToken, login, logout, oauthLogin, signup, updateProfile, isAdmin, isCandidate, isClient }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
